export default __webpack_public_path__ + "pgnv-assets/c61db0a990949079dbbbd2033a1620c8.png";